import {BaseModel} from '../../_base/crud';

export class Product extends BaseModel {
	id: number;
	code: string;
	name: string;
	imagePath: string;
	productCategoryId: number;
	productCategoryName: string;
	active: boolean;
	productShape: string;
	height: number;
	width: number;
	length: number;
	volume: number;
    productMaterials: any;
}

export class ProductCategory {
	id: number;
	name: string;
	vatPercentage: number;
}

export class ProductShape {
	id: number;
	name: string;
	value: string;
}

export const productShapes = [
	{
		id: 0,
		name: 'Amorfo',
		value: 'Shapeless',
	},
	{
		id: 1,
		name: 'Cilíndrico',
		value: 'Cilinder',
	},
	{
		id: 2,
		name: 'Rectangular',
		value: 'Rectangular',
	},
];

export const shapesMap = {
	'Shapeless': 'Amorfo',
	'Cilinder': 'Cilíndrico',
	'Rectangular': 'Rectangular',
};
